document.addEventListener('DOMContentLoaded', function () {
  console.log('Tabs JS loaded'); // debug

  const allTabs = document.querySelectorAll('.nutri-tabs');

  allTabs.forEach(function (tabsWrap) {

    const targetSelector = tabsWrap.getAttribute('data-target');
    if (!targetSelector) return;

    const grid = document.querySelector(targetSelector);
    if (!grid) {
      console.log('Grid not found:', targetSelector);
      return;
    }

    const tabs = tabsWrap.querySelectorAll('.nutri-tab');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {

        const filter = (tab.getAttribute('data-filter') || '').toLowerCase();
        const cards = grid.querySelectorAll('.nutri-product-card');

        console.log('Clicked:', filter);

        tabs.forEach(function (btn) {
          btn.classList.remove('active');
          btn.setAttribute('aria-pressed', 'false');
        });

        tab.classList.add('active');
        tab.setAttribute('aria-pressed', 'true');

        cards.forEach(function (card) {
          const category = (card.getAttribute('data-category') || '').toLowerCase();

          if (filter === 'all' || category === filter) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });

      });
    });

  });
});

document.addEventListener("DOMContentLoaded", function () {
  function updateYotpoCounts() {
    document.querySelectorAll('.nutri-review-count').forEach(function (el) {
      const row = el.closest('.nutri-rating-row');
      if (!row) return;

      const textEl = row.querySelector('.yotpo.bottomLine .text-m');
      if (!textEl) return;

      const label = textEl.getAttribute('aria-label') || textEl.textContent || '';
      const number = label.replace(/\D/g, '');

      if (number) {
        el.textContent = '(' + number + ')';
      }
    });
  }

  setTimeout(updateYotpoCounts, 1500);
  setTimeout(updateYotpoCounts, 2500);
});